// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_f9-0";
export var fileCarousel = "_f9-2";
export var removeFileButton = "_f9-1";